
import React from 'react';
import StartupEcosystem from './StartupEcosystem';
import { useContent } from 'hooks/useContent';
import ContributionSection from './ContributionSection';

interface FdiPerformanceCard {
    id: string;
    title: string;
    content: string;
}

interface FdiPerformanceHeader {
    icon: string;
    tagline: string;
    heading: string;
    description?:string;
}

interface FdiPerformanceStatistics {
    id: string;
    title: string;
    statistics: string;
}

interface FdiPerformanceData {
    id: string;
    header: FdiPerformanceHeader;
    cards: FdiPerformanceCard[];
    statisticsCard: FdiPerformanceStatistics;
}

interface FdiPerformanceProps {
    data: FdiPerformanceData;
}

const FDIPerformance: React.FC<FdiPerformanceProps> = ({
    data
}) => {

     const { content } = useContent();

    return (
        <>
            <section id={data.id}>
                <div className="section-intro yellow">
                    <div className="section-intro-header">
                        <h1 className="number-display white">
                            <span dangerouslySetInnerHTML={{ __html: data.header.icon }} />
                        </h1>
                        <div className="tagline-heading light">{data.header.tagline}</div>
                        <h2 className="heading-1 light">{data.header.heading}</h2>
                        <p className="paragraph-large light">{data.header.description}</p>
                    </div>
                </div>
            </section>
            <section className="section-regular background-cream postintro">
                <div className="container-large postintro">
                    <div className="bento-w-heading">
                        <div className="bento-grid-wrapper">
                            <div className="w-layout-grid bento-grid _3-columns">
                                {data.cards.map((card) => (
                                    <div key={card.id} id={card.id} className="bento-card">
                                        <div className="bento-card-header">
                                            <div className="wrap-v-small">
                                                <h3 className="h4-heading">
                                                    <strong>{card.title}</strong>
                                                </h3>
                                                <div
                                                    className="description w-richtext"
                                                    dangerouslySetInnerHTML={{ __html: card.content }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div id={data.statisticsCard.id} className="bento-card">
                                    <div className="bento-card-header">
                                        <div className="content-card">
                                            <div
                                                className="content-statistics-wrapper"
                                                dangerouslySetInnerHTML={{ __html: data.statisticsCard.statistics }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <StartupEcosystem data={content.startupEcosystem} />

            <ContributionSection data={content.contributionSection} />
        </>
    );
};

export default FDIPerformance;
